import { Modal, Upload, Button, Space, message } from "antd";
import React, {useState} from 'react'
import { UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import service from "../../../../@services";
import { getRequestHeader } from "../../../../@utils/request.js";
import * as Utils from '../../../../@utils';
import config from "../../../../@config";
export default ({ visible, storeCode = [], close = () => { } }) => {
  const [downLoadUrl, setDownLoadUrl] = useState('');
  
  // 修改关闭函数，在关闭时重置downLoadUrl
  const handleClose = () => {
    setDownLoadUrl('');
    close();
  };

  const onFileUploadSuccess = (file) => {
    if (!file || file.status != "done") return
    if (file.status == 'done') {
      if (file.response.code === 200) {
        if (file.response.data && file.response.data.errorFilePath) {
          message.error("导入失败")
          // 确保URL使用HTTPS协议以避免混合内容问题
          const errorFileUrl = file.response.data.errorFilePath;
          const secureUrl = errorFileUrl.startsWith('http://') 
            ? errorFileUrl.replace('http://', 'https://') 
            : errorFileUrl;
          setDownLoadUrl(secureUrl);
        } else {
          message.success("导入数据成功")
        }
      } else {
        setDownLoadUrl('');
        message.error(file.response.message || '导入失败', 5)
      }
    }
  }
  const downloadTemplate = () => {
    service.common.getFileTemplate({ fileType: 'orderDeliveryTemplate' }).then((res) => {
      Utils.download(res, '订单发货批量导入模版.xlsx')
    })
  }
  return (
    <Modal
      title="批量导入"
      visible={visible}
      onCancel={handleClose}
      footer={[
        <Button key="back" onClick={handleClose}>关闭</Button>
      ]}
    >
      {
        <Space style={{ display: "flex", justifyContent: "center", padding: "50px 0" }}>
          <Upload
            action={config.BASE_API + "/order-delivery/import?storeCode=" + storeCode.join('')}
            showUploadList={false}
            headers={getRequestHeader()}
            onChange={({ file }) => onFileUploadSuccess(file)}
          >
            <Button type="primary" icon={<UploadOutlined />}>上传文件</Button>
          </Upload>
          <Button type="primary" icon={<DownloadOutlined />} onClick={downloadTemplate}>下载模版</Button>
        </Space>
      }
      {
        downLoadUrl ? 
          <div className="tips" style={{ color: '#b4b7b8', fontSize: '12px', textAlign: 'center' }}>
            导入失败，支持下载错误文件查看失败原因
            {/* 使用标准的href属性和download属性 */}
            <a href={downLoadUrl} download style={{ marginLeft: '8px' }}>
              下载报错文件
            </a>
          </div> 
        : null
      }  
    </Modal>
  )
}